import { useState, useEffect } from "react";

// Sirka okna, ktora sa naozaj aktualizuje.
//
// Modaly si sirku citali ako `window.innerWidth` pri vykresleni a viac sa na
// nu nepozreli. Ked clovek otocil tablet alebo zmenil velkost okna, okno
// zostalo siroke podla povodneho stavu, takze na mobile bolo uzke a na velkej
// obrazovke zase zbytocne male. Tento hook na zmenu reaguje.
export const useSirkaOkna = () => {
  const [sirka, setSirka] = useState(
    typeof window === "undefined" ? 1200 : window.innerWidth
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    let cas = null;
    const prepocitaj = () => {
      // Pri tahani za roh sa udalost spusta desiatky krat za sekundu.
      clearTimeout(cas);
      cas = setTimeout(() => setSirka(window.innerWidth), 150);
    };
    window.addEventListener("resize", prepocitaj);
    window.addEventListener("orientationchange", prepocitaj);
    return () => {
      clearTimeout(cas);
      window.removeEventListener("resize", prepocitaj);
      window.removeEventListener("orientationchange", prepocitaj);
    };
  }, []);

  return sirka;
};

// Sirka modalu podla obrazovky. Na mobile takmer cela sirka, na velkom
// monitore sa prestane rozsirovat, aby sa formulare nerozťahovali do nezmyslu.
export const sirkaModalu = (sirkaOkna) => {
  if (sirkaOkna <= 575) return "96vw";
  if (sirkaOkna <= 991) return "92vw";
  return Math.min(1180, Math.round(sirkaOkna * 0.85));
};

export default useSirkaOkna;
